import React, {ReactNode} from 'react';
import I18n from 'app/i18n';
import {betMoney} from 'app/utils';

interface Props {
    disabled?: boolean
    onClick: () => void
    onAllIn: () => void
    isAllIn: boolean
    isRaise: boolean
    amount: string | number
}

export default class PokerPanelButtonBetRaise extends React.Component<Props> {
    renderName = (): string => {
        const {isAllIn, isRaise} = this.props;

        if (isAllIn) {
            return I18n.t('poker.all_in_bank');
        } else if (isRaise) {
            return I18n.t('poker.raise');
        }

        return I18n.t('poker.bet');
    };

    render(): ReactNode {
        const {onClick, onAllIn, isAllIn, disabled, amount} = this.props;
        return <button
            className="button-adaptive bet"
            disabled={disabled}
            onClick={isAllIn ? onAllIn : onClick}
        >
            <>
                <span className="button-name">{this.renderName()}</span>
                <span className="button-subtitle">{betMoney({amount})}</span>
            </>
        </button>;
    }
}
